<div class="panelLocations"  [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" id="panelLocationContainer">
  <loading [isLoading]="isLoading"></loading>
  
   <div class="header-panel">

    <div class="btnClose" *ngIf="panelLocationsService.canClosePanel | async">
      <!-- <mat-icon class="close-button" matTooltip="Cerrar" (click)="ClosePanel()">cancel</mat-icon> -->
       <img [src]="'cancelar.svg' | findUrl" (click)="ClosePanel()">
    </div>

    <h3>Control de Activos</h3>

    <div class="tools-buttons-container">
      <!-- <div class="tool-button" (click)="isSearchButtonPressed = !isSearchButtonPressed; isToolButtonPressed = false" id="searchLocationButton" matTooltip="Buscar Activo">
        <img [src]="'busqueda_blanco.svg' | findUrl">
      </div> -->
      <div class="tool-button" (click)="isToolButtonPressed = !isToolButtonPressed; isSearchButtonPressed = false" id="toolsLocationButton" matTooltip="Buscar Activo">
        <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
        <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
      </div>
    </div>

   </div>

   <div [@mostrarFiltro]="!isToolButtonPressed?'visible':'hidden'" class="search-Arrow-flex">
    <div class="searchBar-flex">
      <div class="searchBar" id="searchLocationInput" mat-tooltip="Buscar por Identificador" matTooltipPosition="above">
        <mat-form-field class="width-input">
          <input
            #filterGlobal
            [(ngModel)]="globalFinder"
            matInput
            placeholder="Búsqueda por Identificador"
            spellcheck="false"
            type="text"
            (input)="onSearchInput(filterGlobal.value)"
          />
        </mat-form-field>
      </div>
      <div class="btnResetFilter-container" (click)="resetGlobalFilterValue()" *ngIf="globalFinder.length > 0">
        <mat-icon  matTooltip="Borrar" aria-hidden="false" >cancel</mat-icon>
      </div>
      <div class="btnSearch-container" (click)="onGlobalFilterButton(filterGlobal.value)">
        <img class="btnSearchIcon" src="/assets/img/icon_search.png" *ngIf="globalFinder.length == 0">
      </div>
    </div>
    
    <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
    </div>
    <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
    </div>
   </div>

  <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical" id="panelLocationButtonToolContainer">
    <location-button-toolbar 
      [showFilter]="showFilter"
      [isGlobal]="true"
      [btnDownExcel]="true" 
      [isLocationFilter]="isGlobalFilterActive"
      [panelGlobalFinder]="globalFinder"
      [globalFilterIdentifiers]="globalFilterIdentifiers"
      [excelDownloadOperation]="excelDownloadOperation"
      [idLocationCategory]="selectedCategoryTab ? selectedCategoryTab.category.id : 0"
      [filtersObject]="filtersObject"
      [ApplyFilter]="ApplyFilter"
      [isVerticalList]="true"
      (filterResponse)="filterResponse($event)">
    </location-button-toolbar>

    <app-report-list 
      id="panelLocationReportsButton" 
      [showReportes]="isVisibleGPSTabs"
      [isGlobal]="true"
      [isVerticalList]="true">
    </app-report-list>
  </div>

   <div class="center-item filter-list" *ngIf="isGlobalFilterActive">
    <!-- <div class="center-item">
      <div class="section-header-background">
        <h3>Resultado de búsqueda </h3> 
      </div>
    </div> -->
    <div class="control-items">
      <div class="itemPanel" *ngFor="let item of $itemsFilterGlobal" (click)="onCardClicked(item.location)">
        <div class="row itemPanel-flex">
          <!-- <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
            GBR
          </div> -->
          <div class="item-left">
            <!-- <img class="item-icon" [src]="'/assets/img/' + item.icon" width="25px"> -->
            <img class="item-icon" [src]="item.location.panelIcon | findUrl" width="25px">
          </div>
          <div class="row-item item-middle">
            <div *ngIf="item.location.statusFlags != null && item.location.statusFlags.length > 0" class="status-flag-section">
              <div class="status-flag-set-locations">
                <mat-icon *ngFor="let flag of item.location.statusFlags" [matTooltip]="flag.flagName" class="status-flag-icon">{{flag.flagIcon}}</mat-icon>
              </div>
            </div>
            <label [ngClass]="{'title-item-act': item.tipo == 'Actualizado', 'title-item-des': item.tipo == 'Desactualizado', 'title-item-off': item.tipo == 'Desconectado' }">
              <strong>{{item.location.identifier}}</strong>
            </label>
            <label class="subtitle-item"><strong>{{item.location.description}}</strong></label>
            <label class="subtitle-item"><strong>{{item.location.alias}}</strong></label>
          </div>
          <div class="item-right" (click)="copyToClipboard(item.location.identifier); $event.stopPropagation()">
            <div class="copy-to-clipboard">
              <img [src]="'boton_copiar_azul.svg' | findUrl">
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="$itemsFilterGlobal.length == 0 && !isLoading">
        <div class="row-item col-12">
          <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
        </div>
      </div>
    </div>
  </div>

    <div class="locations-tab-group">
      <mat-tab-group mat-stretch-tabs (selectedTabChange)="selectTab($event)" *ngIf="!isGlobalFilterActive" id="panelLocationTabContent">
        <!-- tab de actualizados -->
      
       <mat-tab *ngIf="isVisibleGPSTabs" [label]="'1'">
         <ng-template mat-tab-label matTooltip="Activos que se actualizaron en las últimas 12 horas." matTooltipPosition="above">
          <div id="panelLocationActiveTab" >
            <label class="gps-label">GPS</label>
            <label class="totals-label" >
           <img src="/assets/img/locationPanel/gps_activo.svg">
            {{totalActualizados}} Online 
            </label>
          </div> 
         </ng-template>
         <ng-template matTabContent >
            <!-- <div class="section-footer-background"></div> -->
               <div *ngIf="selectedTabIndex == 1" class="tab-content-wrapper">
               <div class="control-items"  (scroll)="onScroll($event)">
                 <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                   <div class="row itemPanel-flex">
                    <!-- esta hardcodeado para gbr, pero se puede agregar para cualquiera -->
                    <!-- <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                      GBR
                    </div> -->
                     <div class="item-left">
                       <img class="item-icon" [src]="item.panelIcon | findUrl" width="25px">
                     </div>
                     <div class="row-item item-middle">
                      <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                        <div class="status-flag-set-locations">
                          <mat-icon *ngFor="let flag of item.statusFlags" [matTooltip]="flag.flagName" class="status-flag-icon">{{flag.flagIcon}}</mat-icon>
                        </div>
                      </div>
                      <label class="title-item-act"><strong>{{item.identifier}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.alias}}</strong></label>
                     </div>
                     <div class="item-right" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                        <div class="copy-to-clipboard">
                      <img [src]="'boton_copiar_azul.svg' | findUrl">
                    </div>
                      </div>
                   </div>
                 </div>

                 <div class="row" *ngIf="$Items.length == 0 && !isLoading">
                   <div class="row-item ">
                     <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
                   </div>
                 </div>
               </div>
             </div>
         </ng-template>
       </mat-tab>
       <!-- tab desactualizados -->
       <mat-tab *ngIf="isVisibleGPSTabs" [label]="'2'" >
         <ng-template mat-tab-label matTooltip="Activos que NO se actualizaron en las últimas 12 horas." matTooltipPosition="above">
          <div id="panelLocationInactiveTab">
            <label class="gps-label">GPS</label>
            <label class="totals-label" >
              <img src="/assets/img/locationPanel/gps_rojo.svg">
              {{totalDesactualizados}}  Offline 
            </label> 
          </div>
         </ng-template>
         <ng-template matTabContent>
          <!-- <div class="section-footer-background"></div> -->
           <div *ngIf="selectedTabIndex == 2" class="tab-content-wrapper" >
           <div class="control-items"  (scroll)="onScroll($event)">
             <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
               <div class="row itemPanel-flex">
                 <div class="item-left">
                   <img class="item-icon" [src]="item.panelIcon | findUrl" width="25px">
                 </div>
                 <div class="row-item item-middle">
                  <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                    <div class="status-flag-set-locations">
                      <mat-icon *ngFor="let flag of item.statusFlags" [matTooltip]="flag.flagName" class="status-flag-icon" [style.color]="flag.priorityHex">{{flag.flagIcon}}</mat-icon>
                    </div>
                  </div>
                   <label class="title-item-des"><strong>{{item.identifier}}</strong></label>
                   <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                   <label class="subtitle-item"><strong>{{item.alias}}</strong></label>
                 </div>
                 <div class="item-right" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                    <div class="copy-to-clipboard">
                      <img [src]="'boton_copiar_azul.svg' | findUrl">
                    </div>
                  </div>
               </div>
             </div>
             <div class="row" *ngIf="$Items.length == 0 && !isLoading">
               <div class="row-item col-12">
                 <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
               </div>
             </div>
           </div>
         </div>
         </ng-template>
       </mat-tab>
         <!-- tab sin reporte -->
       <mat-tab *ngIf="isVisibleGPSTabs" [label]="'3'">
         <ng-template mat-tab-label  matTooltip="Activos que NO han presentado actualización de GPS." matTooltipPosition="above">
          <div id="panelLocationDisconectedTab">
            <label class="gps-label">GPS</label>
            <label class="totals-label">
              <img src="/assets/img/locationPanel/gps_tache.svg">
            {{(totalSinReporte)}} S/R
            </label>
          </div>
         </ng-template>
         <ng-template matTabContent>
          <!-- <div class="section-footer-background"></div> -->
               <div *ngIf="selectedTabIndex == 3" class="tab-content-wrapper" >
               <div class="control-items"  (scroll)="onScroll($event)">
                 <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                   <div class="row itemPanel-flex">
                    <!-- esta hardcodeado para gbr, pero se puede agregar para cualquiera -->
                    <!-- <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                      GBR
                    </div> -->
                     <div class="item-left">
                       <img class="item-icon" [src]="item.panelIcon | findUrl" >
                     </div>
                     <div class="row-item item-middle">
                      <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                        <div class="status-flag-set-locations">
                          <mat-icon *ngFor="let flag of item.statusFlags" [matTooltip]="flag.flagName" class="status-flag-icon" [style.color]="flag.priorityHex">{{flag.flagIcon}}</mat-icon>
                        </div>
                      </div>
                      <label class="title-item-off"><strong>{{item.identifier}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                      <label class="subtitle-item"><strong>{{item.alias}}</strong></label>
                     </div>
                     <div class="item-right" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                        <div class="copy-to-clipboard">
                          <img [src]="'boton_copiar_azul.svg' | findUrl">
                        </div>
                      </div>
                   </div>
                 </div>

                 <div class="row" *ngIf="$Items.length == 0 && !isLoading">
                   <div class="row-item ">
                     <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
                   </div>
                 </div>
               </div>
             </div>
         </ng-template>
       </mat-tab>
   
       <!-- tabs de categorias dinámico-->
        
        <div *ngFor="let categoryItem of categoriesTabs; let i = index" class="categoryTabs">
          <mat-tab  *ngIf="categoryItem.isVisible && allowedParts?.allowedCategories?.includes(categoryItem.category.id.toString())" [label]="(i + 4).toString()">
            <ng-template mat-tab-label>
              <div id="panelLocationDisconectedTab" class="categoryTabLabel">
                
                <img [src]="categoryItem.category.panelIcon | findUrl" width="25px">
                <label class="totals-label">
                 {{categoryItem.total}} {{categoryItem.category.shortName}}
                </label>
              </div>
            </ng-template>

            <ng-template matTabContent>
              <!-- <div class="section-footer-background"></div> -->
              
              <div *ngIf="categoryItem.category.layerFilter_IsFiltered" class="tab-content-wrapper">

                <div class="itemPanel add-new-location-card" [ngClass]="{'add-new-location-disabled': (isLoading || filteredCategoryTab.isLoading)}" *ngIf="categoryItem.category.canBeCreated && filteredCategoryTab.hasAppliedFilter" (click)="openCreateLocationDialog(categoryItem.category, filteredCategoryTab.locations)">
                  <div class="row itemPanel-flex">
                    <div class="item-left">
                      <mat-icon class="add-new-location-icon">add</mat-icon>
                    </div>
                    <div class="row-item item-middle">
                      <label class="title-item-act"><strong>Agregar nuevo</strong></label>
                    </div>
                    <div class="item-right"></div>
                  </div>
                </div>

                <app-filtered-category-tab
                  #filteredCategoryTab
                  [filtersObject]="filtersObject"
                  [selectedCategoryItem]="categoryItem.category"
                  (onCardClickedEmitter)="onCardClicked($event)"
                  (categoryTotalUpdated)="updateCategoryTotal($event)">
                </app-filtered-category-tab>
              </div>

              <div *ngIf="!categoryItem.category.layerFilter_IsFiltered" class="tab-content-wrapper">

                <div class="itemPanel add-new-location-card" [ngClass]="{'add-new-location-disabled': isLoading}" *ngIf="categoryItem.category.canBeCreated" (click)="openCreateLocationDialog(categoryItem.category, $Items)">
                  <div class="row itemPanel-flex">
                    <div class="item-left">
                      <mat-icon class="add-new-location-icon">add</mat-icon>
                    </div>
                    <div class="row-item item-middle">
                      <label class="title-item-act"><strong>Agregar nuevo</strong></label>
                    </div>
                    <div class="item-right"></div>
                  </div>
                </div>

                <div class="control-items" (scroll)="onScroll($event)">
                  <div class="itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item)">
                    <div class="row itemPanel-flex">
                      <div class="item-left">
                        <img class="item-icon" [src]="(item.panelIcon || categoryItem.category.panelIcon) | findUrl" >
                      </div>
                      <div class="row-item item-middle">
                        <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                          <div class="status-flag-set-locations">
                            <mat-icon *ngFor="let flag of item.statusFlags" [matTooltip]="flag.flagName" class="status-flag-icon" [style.color]="flag.priorityHex">{{flag.flagIcon}}</mat-icon>
                          </div>
                        </div>
                        <label class="title-item-act"><strong>{{item.identifier}}</strong></label>
                        <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                      </div>
                      <div class="item-right" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                        <div class="copy-to-clipboard">
                          <img [src]="'boton_copiar_azul.svg' | findUrl">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="$Items.length == 0 && !isLoading">
                    <div class="row-item col-12">
                      <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </div>
        
        
     </mat-tab-group>
    </div>

    <div class="">
      <!-- <div class="section-footer-background">
      </div> -->
    </div>

</div>
